export type UserTag = number;

export const getInfo = (tag: UserTag, isTitle = false) => {
  let label = '';
  if (1101 <= tag && tag <= 1110) {
    const item = ageList.find(list => list.tag === tag);
    label = item !== undefined ? item.label : '';
  } else if (1200 <= tag && tag < 1239) {
    const item = assetsList.find(list => list.tag === tag);
    label = item !== undefined ? `${item.labelFrom}～${item.labelTo}` : '';
  } else if (tag === 1239) {
    const item = assetsList.find(list => list.tag === tag);
    label = item !== undefined ? `${item.labelFrom}` : '';
  } else if (1300 <= tag && tag < 1400) {
    const item = annualIncomeList.find(list => list.tag === tag);
    label = item !== undefined ? `${item.labelFrom}～${item.labelTo}` : '';
  } else if (tag === 1400) {
    const item = annualIncomeList.find(list => list.tag === tag);
    label = item !== undefined ? `${item.labelFrom}` : '';
  } else if (tag === 1401 || tag === null) {
    label = '---';
  } else if (1500 <= tag && tag <= 1506) {
    const item = investmentStartYearList.find(list => list.tag === tag);
    label = item !== undefined ? item.label : '';
  } else if (2101 <= tag && tag <= 2202) {
    const item = investmentProductsList.find(list => list.tag === tag);
    label = item !== undefined ? item.label : '';
  } else {
    label = '---';
  }

  let title = '';
  if (isTitle) {
    if (1200 <= tag && tag <= 1239) {
      title = '資産総額 ';
    } else if (1300 <= tag && tag <= 1400) {
      title = '年収 ';
    } else if (1500 <= tag && tag <= 1506) {
      title = '投資歴 ';
    }
  }

  return `${title}${label}`;
};

export const getInfoFrom = (tag: UserTag | null) => {
  let label = '';
  if (tag === null) {
    label = '---';
  } else if (1200 <= tag && tag <= 1239) {
    const item = assetsList.find(list => list.tag === tag);
    label = item !== undefined ? item.labelFrom : '';
  } else if (1300 <= tag && tag <= 1400) {
    const item = annualIncomeList.find(list => list.tag === tag);
    label = item !== undefined ? item.labelFrom : '';
  } else {
    label = '---';
  }
  const unit = tag === 1239 || tag === 1400 || tag === null ? '' : '～';

  return `${label}${unit}`;
};

export const getInfoTo = (tag: UserTag | null) => {
  let label = '';
  if (tag === null) {
    label = '';
  } else if (1200 <= tag && tag <= 1239) {
    const item = assetsList.find(list => list.tag === tag);
    label = item !== undefined ? item.labelTo : '';
  } else if (1300 <= tag && tag <= 1400) {
    const item = annualIncomeList.find(list => list.tag === tag);
    label = item !== undefined ? item.labelTo : '';
  }

  return `${label}`;
};

export const getUnit = (tag: UserTag | null) => {
  if (tag === null) {
    return '';
  } else if (1101 <= tag && tag <= 1109) {
    return '代';
  } else if (tag === 1110) {
    return '代以上';
  } else if (1200 <= tag && tag <= 1238) {
    return '万円';
  } else if (tag === 1239) {
    return '円～';
  } else if (1300 <= tag && tag <= 1399) {
    return '万円';
  } else if (tag === 1400) {
    return '円～';
  } else if (tag === 1401) {
    return '円';
  } else if (tag === 1500) {
    return '年未満';
  } else if (1501 <= tag && tag <= 1505) {
    return '年';
  } else if (tag === 1506) {
    return '年以上';
  } else {
    return '';
  }
};

export const getColor = (tag: number) => {
  if (2101 <= tag && tag <= 2202) {
    const item = investmentProductsList.find(list => list.tag === tag);
    return item !== undefined ? item.color : null;
  } else {
    return null;
  }
};

export type NotSelected = -1;

export type AgeDropDownList = {
  type: AgeDropDownType | NotSelected;
  label: string;
  tag: UserTag | null;
  filterFlag: boolean;
};
export type AgeDropDownType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export const ageList = [
  {
    type: 1,
    tag: 1101,
    label: '10',
    filterFlag: true,
  },
  {
    type: 2,
    tag: 1102,
    label: '20',
    filterFlag: true,
  },
  {
    type: 3,
    tag: 1103,
    label: '30',
    filterFlag: true,
  },
  {
    type: 4,
    tag: 1104,
    label: '40',
    filterFlag: true,
  },
  {
    type: 5,
    tag: 1105,
    label: '50',
    filterFlag: true,
  },
  {
    type: 6,
    tag: 1106,
    label: '60',
    filterFlag: true,
  },
  {
    type: 7,
    tag: 1107,
    label: '70',
    filterFlag: true,
  },
  {
    type: 8,
    tag: 1108,
    label: '80',
    filterFlag: false,
  },
  {
    type: 9,
    tag: 1109,
    label: '90',
    filterFlag: false,
  },
  {
    type: 10,
    tag: 1110,
    label: '100',
    filterFlag: false,
  },
] as AgeDropDownList[];

export type AssetsDropDownList = {
  type: AssetsDropDownType | NotSelected;
  labelFrom: string;
  labelTo: string;
  tag: UserTag | null;
  filterFlag: boolean;
};
export type AssetsDropDownType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32;

export const assetsList = [
  {
    type: 1,
    tag: 1200,
    labelFrom: '0',
    labelTo: '99',
    filterFlag: true,
  },
  {
    type: 2,
    tag: 1201,
    labelFrom: '100',
    labelTo: '199',
    filterFlag: true,
  },
  {
    type: 3,
    tag: 1202,
    labelFrom: '200',
    labelTo: '299',
    filterFlag: true,
  },
  {
    type: 4,
    tag: 1203,
    labelFrom: '300',
    labelTo: '399',
    filterFlag: true,
  },
  {
    type: 5,
    tag: 1204,
    labelFrom: '400',
    labelTo: '499',
    filterFlag: true,
  },
  {
    type: 6,
    tag: 1205,
    labelFrom: '500',
    labelTo: '599',
    filterFlag: true,
  },
  {
    type: 7,
    tag: 1206,
    labelFrom: '600',
    labelTo: '699',
    filterFlag: true,
  },
  {
    type: 8,
    tag: 1207,
    labelFrom: '700',
    labelTo: '799',
    filterFlag: true,
  },
  {
    type: 9,
    tag: 1208,
    labelFrom: '800',
    labelTo: '899',
    filterFlag: true,
  },
  {
    type: 10,
    tag: 1209,
    labelFrom: '900',
    labelTo: '999',
    filterFlag: true,
  },
  {
    type: 11,
    tag: 1210,
    labelFrom: '0',
    labelTo: '499',
    filterFlag: false,
  },
  {
    type: 12,
    tag: 1211,
    labelFrom: '500',
    labelTo: '999',
    filterFlag: false,
  },
  {
    type: 13,
    tag: 1212,
    labelFrom: '1000',
    labelTo: '1499',
    filterFlag: true,
  },
  {
    type: 14,
    tag: 1213,
    labelFrom: '1500',
    labelTo: '1999',
    filterFlag: true,
  },
  {
    type: 15,
    tag: 1214,
    labelFrom: '2000',
    labelTo: '2499',
    filterFlag: true,
  },
  {
    type: 16,
    tag: 1215,
    labelFrom: '2500',
    labelTo: '2999',
    filterFlag: true,
  },
  {
    type: 17,
    tag: 1216,
    labelFrom: '3000',
    labelTo: '3499',
    filterFlag: true,
  },
  {
    type: 18,
    tag: 1217,
    labelFrom: '3500',
    labelTo: '3999',
    filterFlag: true,
  },
  {
    type: 19,
    tag: 1218,
    labelFrom: '4000',
    labelTo: '4499',
    filterFlag: true,
  },
  {
    type: 20,
    tag: 1219,
    labelFrom: '4500',
    labelTo: '4999',
    filterFlag: true,
  },
  {
    type: 21,
    tag: 1220,
    labelFrom: '0',
    labelTo: '999',
    filterFlag: false,
  },
  {
    type: 22,
    tag: 1221,
    labelFrom: '1000',
    labelTo: '1999',
    filterFlag: false,
  },
  {
    type: 23,
    tag: 1222,
    labelFrom: '2000',
    labelTo: '2999',
    filterFlag: false,
  },
  {
    type: 24,
    tag: 1223,
    labelFrom: '3000',
    labelTo: '3999',
    filterFlag: false,
  },
  {
    type: 25,
    tag: 1224,
    labelFrom: '4000',
    labelTo: '4999',
    filterFlag: false,
  },
  {
    type: 26,
    tag: 1225,
    labelFrom: '5000',
    labelTo: '5999',
    filterFlag: true,
  },
  {
    type: 27,
    tag: 1226,
    labelFrom: '6000',
    labelTo: '6999',
    filterFlag: true,
  },
  {
    type: 28,
    tag: 1227,
    labelFrom: '7000',
    labelTo: '7999',
    filterFlag: true,
  },
  {
    type: 29,
    tag: 1228,
    labelFrom: '8000',
    labelTo: '8999',
    filterFlag: true,
  },
  {
    type: 30,
    tag: 1229,
    labelFrom: '9000',
    labelTo: '9999',
    filterFlag: true,
  },
  {
    type: 31,
    tag: 1230,
    labelFrom: '0',
    labelTo: '9999',
    filterFlag: false,
  },
  {
    type: 32,
    tag: 1231,
    labelFrom: '1億',
    labelTo: '1億4999',
    filterFlag: true,
  },
  {
    type: 33,
    tag: 1232,
    labelFrom: '1億5000',
    labelTo: '1億9999',
    filterFlag: true,
  },
  {
    type: 34,
    tag: 1233,
    labelFrom: '2億',
    labelTo: '2億4999',
    filterFlag: true,
  },
  {
    type: 35,
    tag: 1234,
    labelFrom: '2億5000',
    labelTo: '2億9999',
    filterFlag: true,
  },
  {
    type: 36,
    tag: 1235,
    labelFrom: '3億',
    labelTo: '3億4999',
    filterFlag: true,
  },
  {
    type: 37,
    tag: 1236,
    labelFrom: '3億5000',
    labelTo: '3億9999',
    filterFlag: true,
  },
  {
    type: 38,
    tag: 1237,
    labelFrom: '4億',
    labelTo: '4億4999',
    filterFlag: true,
  },
  {
    type: 39,
    tag: 1238,
    labelFrom: '4億5000',
    labelTo: '4億9999',
    filterFlag: true,
  },
  {
    type: 40,
    tag: 1239,
    labelFrom: '5億',
    labelTo: '',
    filterFlag: true,
  },
] as AssetsDropDownList[];

export type AnnualIncomeDropDownList = {
  type: AnnualIncomeDropDownType | NotSelected;
  labelFrom: string;
  labelTo: string;
  tag: UserTag | null;
  filterFlag: boolean;
};
export type AnnualIncomeDropDownType =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30
  | 31
  | 32
  | 33
  | 34
  | 35
  | 36
  | 37
  | 38
  | 39
  | 40
  | 41
  | 42
  | 43
  | 44
  | 45
  | 46
  | 47
  | 48
  | 49
  | 50
  | 51
  | 52
  | 53
  | 54
  | 55
  | 56
  | 57
  | 58
  | 59
  | 60
  | 61
  | 62
  | 63
  | 64
  | 65
  | 66
  | 67
  | 68
  | 69
  | 70
  | 71
  | 72
  | 73
  | 74
  | 75
  | 76
  | 77
  | 78
  | 79
  | 80
  | 81
  | 82
  | 83
  | 84
  | 85
  | 86
  | 87
  | 88
  | 89
  | 90
  | 91
  | 92
  | 93
  | 94
  | 95
  | 96
  | 97
  | 98
  | 99
  | 100
  | 101
  | 102;

export const annualIncomeList = [
  {
    type: 1,
    tag: 1300,
    labelFrom: '0',
    labelTo: '99',
    filterFlag: true,
  },
  {
    type: 2,
    tag: 1301,
    labelFrom: '100',
    labelTo: '199',
    filterFlag: true,
  },
  {
    type: 3,
    tag: 1302,
    labelFrom: '200',
    labelTo: '299',
    filterFlag: true,
  },
  {
    type: 4,
    tag: 1303,
    labelFrom: '300',
    labelTo: '399',
    filterFlag: true,
  },
  {
    type: 5,
    tag: 1304,
    labelFrom: '400',
    labelTo: '499',
    filterFlag: true,
  },
  {
    type: 6,
    tag: 1305,
    labelFrom: '500',
    labelTo: '599',
    filterFlag: true,
  },
  {
    type: 7,
    tag: 1306,
    labelFrom: '600',
    labelTo: '699',
    filterFlag: true,
  },
  {
    type: 8,
    tag: 1307,
    labelFrom: '700',
    labelTo: '799',
    filterFlag: true,
  },
  {
    type: 9,
    tag: 1308,
    labelFrom: '800',
    labelTo: '899',
    filterFlag: true,
  },
  {
    type: 10,
    tag: 1309,
    labelFrom: '900',
    labelTo: '999',
    filterFlag: true,
  },
  {
    type: 11,
    tag: 1310,
    labelFrom: '1000',
    labelTo: '1099',
    filterFlag: true,
  },
  {
    type: 12,
    tag: 1311,
    labelFrom: '1100',
    labelTo: '1199',
    filterFlag: true,
  },
  {
    type: 13,
    tag: 1312,
    labelFrom: '1200',
    labelTo: '1299',
    filterFlag: true,
  },
  {
    type: 14,
    tag: 1313,
    labelFrom: '1300',
    labelTo: '1399',
    filterFlag: true,
  },
  {
    type: 15,
    tag: 1314,
    labelFrom: '1400',
    labelTo: '1499',
    filterFlag: true,
  },
  {
    type: 16,
    tag: 1315,
    labelFrom: '1500',
    labelTo: '1599',
    filterFlag: true,
  },
  {
    type: 17,
    tag: 1316,
    labelFrom: '1600',
    labelTo: '1699',
    filterFlag: true,
  },
  {
    type: 18,
    tag: 1317,
    labelFrom: '1700',
    labelTo: '1799',
    filterFlag: true,
  },
  {
    type: 19,
    tag: 1318,
    labelFrom: '1800',
    labelTo: '1899',
    filterFlag: true,
  },
  {
    type: 20,
    tag: 1319,
    labelFrom: '1900',
    labelTo: '1999',
    filterFlag: true,
  },
  {
    type: 21,
    tag: 1320,
    labelFrom: '2000',
    labelTo: '2099',
    filterFlag: true,
  },
  {
    type: 22,
    tag: 1321,
    labelFrom: '2100',
    labelTo: '2199',
    filterFlag: true,
  },
  {
    type: 23,
    tag: 1322,
    labelFrom: '2200',
    labelTo: '2299',
    filterFlag: true,
  },
  {
    type: 24,
    tag: 1323,
    labelFrom: '2300',
    labelTo: '2399',
    filterFlag: true,
  },
  {
    type: 25,
    tag: 1324,
    labelFrom: '2400',
    labelTo: '2499',
    filterFlag: true,
  },
  {
    type: 26,
    tag: 1325,
    labelFrom: '2500',
    labelTo: '2599',
    filterFlag: true,
  },
  {
    type: 27,
    tag: 1326,
    labelFrom: '2600',
    labelTo: '2699',
    filterFlag: true,
  },
  {
    type: 28,
    tag: 1327,
    labelFrom: '2700',
    labelTo: '2799',
    filterFlag: true,
  },
  {
    type: 29,
    tag: 1328,
    labelFrom: '2800',
    labelTo: '2899',
    filterFlag: true,
  },
  {
    type: 30,
    tag: 1329,
    labelFrom: '2900',
    labelTo: '2999',
    filterFlag: true,
  },
  {
    type: 31,
    tag: 1330,
    labelFrom: '3000',
    labelTo: '3099',
    filterFlag: true,
  },
  {
    type: 32,
    tag: 1331,
    labelFrom: '3100',
    labelTo: '3199',
    filterFlag: true,
  },
  {
    type: 33,
    tag: 1332,
    labelFrom: '3200',
    labelTo: '3299',
    filterFlag: true,
  },
  {
    type: 34,
    tag: 1333,
    labelFrom: '3300',
    labelTo: '3399',
    filterFlag: true,
  },
  {
    type: 35,
    tag: 1334,
    labelFrom: '3400',
    labelTo: '3499',
    filterFlag: true,
  },
  {
    type: 36,
    tag: 1335,
    labelFrom: '3500',
    labelTo: '3599',
    filterFlag: true,
  },
  {
    type: 37,
    tag: 1336,
    labelFrom: '3600',
    labelTo: '3699',
    filterFlag: true,
  },
  {
    type: 38,
    tag: 1337,
    labelFrom: '3700',
    labelTo: '3799',
    filterFlag: true,
  },
  {
    type: 39,
    tag: 1338,
    labelFrom: '3800',
    labelTo: '3899',
    filterFlag: true,
  },
  {
    type: 40,
    tag: 1339,
    labelFrom: '3900',
    labelTo: '3999',
    filterFlag: true,
  },
  {
    type: 41,
    tag: 1340,
    labelFrom: '4000',
    labelTo: '4099',
    filterFlag: true,
  },
  {
    type: 42,
    tag: 1341,
    labelFrom: '4100',
    labelTo: '4199',
    filterFlag: true,
  },
  {
    type: 43,
    tag: 1342,
    labelFrom: '4200',
    labelTo: '4299',
    filterFlag: true,
  },
  {
    type: 44,
    tag: 1343,
    labelFrom: '4300',
    labelTo: '4399',
    filterFlag: true,
  },
  {
    type: 45,
    tag: 1344,
    labelFrom: '4400',
    labelTo: '4499',
    filterFlag: true,
  },
  {
    type: 46,
    tag: 1345,
    labelFrom: '4500',
    labelTo: '4599',
    filterFlag: true,
  },
  {
    type: 47,
    tag: 1346,
    labelFrom: '4600',
    labelTo: '4699',
    filterFlag: true,
  },
  {
    type: 48,
    tag: 1347,
    labelFrom: '4700',
    labelTo: '4799',
    filterFlag: true,
  },
  {
    type: 49,
    tag: 1348,
    labelFrom: '4800',
    labelTo: '4899',
    filterFlag: true,
  },
  {
    type: 50,
    tag: 1349,
    labelFrom: '4900',
    labelTo: '4999',
    filterFlag: true,
  },
  {
    type: 51,
    tag: 1350,
    labelFrom: '5000',
    labelTo: '5099',
    filterFlag: true,
  },
  {
    type: 52,
    tag: 1351,
    labelFrom: '5100',
    labelTo: '5199',
    filterFlag: true,
  },
  {
    type: 53,
    tag: 1352,
    labelFrom: '5200',
    labelTo: '5299',
    filterFlag: true,
  },
  {
    type: 54,
    tag: 1353,
    labelFrom: '5300',
    labelTo: '5399',
    filterFlag: true,
  },
  {
    type: 55,
    tag: 1354,
    labelFrom: '5400',
    labelTo: '5499',
    filterFlag: true,
  },
  {
    type: 56,
    tag: 1355,
    labelFrom: '5500',
    labelTo: '5599',
    filterFlag: true,
  },
  {
    type: 57,
    tag: 1356,
    labelFrom: '5600',
    labelTo: '5699',
    filterFlag: true,
  },
  {
    type: 58,
    tag: 1357,
    labelFrom: '5700',
    labelTo: '5799',
    filterFlag: true,
  },
  {
    type: 59,
    tag: 1358,
    labelFrom: '5800',
    labelTo: '5899',
    filterFlag: true,
  },
  {
    type: 60,
    tag: 1359,
    labelFrom: '5900',
    labelTo: '5999',
    filterFlag: true,
  },
  {
    type: 61,
    tag: 1360,
    labelFrom: '6000',
    labelTo: '6099',
    filterFlag: true,
  },
  {
    type: 62,
    tag: 1361,
    labelFrom: '6100',
    labelTo: '6199',
    filterFlag: true,
  },
  {
    type: 63,
    tag: 1362,
    labelFrom: '6200',
    labelTo: '6299',
    filterFlag: true,
  },
  {
    type: 64,
    tag: 1363,
    labelFrom: '6300',
    labelTo: '6399',
    filterFlag: true,
  },
  {
    type: 65,
    tag: 1364,
    labelFrom: '6400',
    labelTo: '6499',
    filterFlag: true,
  },
  {
    type: 66,
    tag: 1365,
    labelFrom: '6500',
    labelTo: '6599',
    filterFlag: true,
  },
  {
    type: 67,
    tag: 1366,
    labelFrom: '6600',
    labelTo: '6699',
    filterFlag: true,
  },
  {
    type: 68,
    tag: 1367,
    labelFrom: '6700',
    labelTo: '6799',
    filterFlag: true,
  },
  {
    type: 69,
    tag: 1368,
    labelFrom: '6800',
    labelTo: '6899',
    filterFlag: true,
  },
  {
    type: 70,
    tag: 1369,
    labelFrom: '6900',
    labelTo: '6999',
    filterFlag: true,
  },
  {
    type: 71,
    tag: 1370,
    labelFrom: '7000',
    labelTo: '7099',
    filterFlag: true,
  },
  {
    type: 72,
    tag: 1371,
    labelFrom: '7100',
    labelTo: '7199',
    filterFlag: true,
  },
  {
    type: 73,
    tag: 1372,
    labelFrom: '7200',
    labelTo: '7299',
    filterFlag: true,
  },
  {
    type: 74,
    tag: 1373,
    labelFrom: '7300',
    labelTo: '7399',
    filterFlag: true,
  },
  {
    type: 75,
    tag: 1374,
    labelFrom: '7400',
    labelTo: '7499',
    filterFlag: true,
  },
  {
    type: 76,
    tag: 1375,
    labelFrom: '7500',
    labelTo: '7599',
    filterFlag: true,
  },
  {
    type: 77,
    tag: 1376,
    labelFrom: '7600',
    labelTo: '7699',
    filterFlag: true,
  },
  {
    type: 78,
    tag: 1377,
    labelFrom: '7700',
    labelTo: '7799',
    filterFlag: true,
  },
  {
    type: 79,
    tag: 1378,
    labelFrom: '7800',
    labelTo: '7899',
    filterFlag: true,
  },
  {
    type: 80,
    tag: 1379,
    labelFrom: '7900',
    labelTo: '7999',
    filterFlag: true,
  },
  {
    type: 81,
    tag: 1380,
    labelFrom: '8000',
    labelTo: '8099',
    filterFlag: true,
  },
  {
    type: 82,
    tag: 1381,
    labelFrom: '8100',
    labelTo: '8199',
    filterFlag: true,
  },
  {
    type: 83,
    tag: 1382,
    labelFrom: '8200',
    labelTo: '8299',
    filterFlag: true,
  },
  {
    type: 84,
    tag: 1383,
    labelFrom: '8300',
    labelTo: '8399',
    filterFlag: true,
  },
  {
    type: 85,
    tag: 1384,
    labelFrom: '8400',
    labelTo: '8499',
    filterFlag: true,
  },
  {
    type: 86,
    tag: 1385,
    labelFrom: '8500',
    labelTo: '8599',
    filterFlag: true,
  },
  {
    type: 87,
    tag: 1386,
    labelFrom: '8600',
    labelTo: '8699',
    filterFlag: true,
  },
  {
    type: 88,
    tag: 1387,
    labelFrom: '8700',
    labelTo: '8799',
    filterFlag: true,
  },
  {
    type: 89,
    tag: 1388,
    labelFrom: '8800',
    labelTo: '8899',
    filterFlag: true,
  },
  {
    type: 90,
    tag: 1389,
    labelFrom: '8900',
    labelTo: '8999',
    filterFlag: true,
  },
  {
    type: 91,
    tag: 1390,
    labelFrom: '9000',
    labelTo: '9099',
    filterFlag: true,
  },
  {
    type: 92,
    tag: 1391,
    labelFrom: '9100',
    labelTo: '9199',
    filterFlag: true,
  },
  {
    type: 93,
    tag: 1392,
    labelFrom: '9200',
    labelTo: '9299',
    filterFlag: true,
  },
  {
    type: 94,
    tag: 1393,
    labelFrom: '9300',
    labelTo: '9399',
    filterFlag: true,
  },
  {
    type: 95,
    tag: 1394,
    labelFrom: '9400',
    labelTo: '9499',
    filterFlag: true,
  },
  {
    type: 96,
    tag: 1395,
    labelFrom: '9500',
    labelTo: '9599',
    filterFlag: true,
  },
  {
    type: 97,
    tag: 1396,
    labelFrom: '9600',
    labelTo: '9699',
    filterFlag: true,
  },
  {
    type: 98,
    tag: 1397,
    labelFrom: '9700',
    labelTo: '9799',
    filterFlag: true,
  },
  {
    type: 99,
    tag: 1398,
    labelFrom: '9800',
    labelTo: '9899',
    filterFlag: true,
  },
  {
    type: 100,
    tag: 1399,
    labelFrom: '9900',
    labelTo: '9999',
    filterFlag: true,
  },
  {
    type: 101,
    tag: 1400,
    labelFrom: '1億',
    labelTo: '',
    filterFlag: true,
  },
  {
    type: 102,
    tag: null,
    labelFrom: '未回答',
    labelTo: '',
    filterFlag: false,
  },
] as AnnualIncomeDropDownList[];

export type InvestmentStartYearDropDownList = {
  type: InvestmentStartYearDropDownType | NotSelected;
  label: string;
  tag: UserTag | null;
};
export type InvestmentStartYearDropDownType = 1 | 2 | 3 | 4 | 5 | 6 | 7;

// 投資歴
export const investmentStartYearList = [
  {
    type: 1,
    tag: 1500,
    label: '1',
  },
  {
    type: 2,
    tag: 1501,
    label: '1～3',
  },
  {
    type: 3,
    tag: 1502,
    label: '3～5',
  },
  {
    type: 4,
    tag: 1503,
    label: '5～10',
  },
  {
    type: 5,
    tag: 1504,
    label: '10～15',
  },
  {
    type: 6,
    tag: 1505,
    label: '15～20',
  },
  {
    type: 7,
    tag: 1506,
    label: '20',
  },
];

export const investmentProductsList = [
  {
    tag: 2101,
    label: '国内株式30％以上',
    color: 'bg-indigo-50 border-indigo-300',
  },
  {
    tag: 2102,
    label: '先進国株式30％以上',
    color: 'bg-indigo-50 border-indigo-300',
  },
  {
    tag: 2103,
    label: '新興国株式',
    color: 'bg-cyan-50 border-blue-250',
  },
  {
    tag: 2104,
    label: '国内債券',
    color: 'bg-cyan-50 border-blue-250',
  },
  {
    tag: 2105,
    label: '先進国債券',
    color: 'bg-cyan-50 border-blue-250',
  },
  {
    tag: 2106,
    label: '新興国債券',
    color: 'bg-cyan-50 border-blue-250',
  },
  {
    tag: 2107,
    label: '国内REIT',
    color: 'bg-cyan-50 border-blue-250',
  },
  {
    tag: 2108,
    label: 'グローバルREIT',
    color: 'bg-cyan-50 border-blue-250',
  },
  {
    tag: 2109,
    label: '現金30％以上',
    color: 'bg-indigo-50 border-indigo-300',
  },
  {
    tag: 2201,
    label: 'NISA',
    color: 'bg-cyan-50 border-blue-250',
  },
  {
    tag: 2202,
    label: '確定拠出年金',
    color: 'bg-cyan-50 border-blue-250',
  },
];
